export const imageUrlToBase64 = imageUrl => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = imageUrl
    image.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = image.naturalWidth // 使用 naturalWidth 为了保证图片的清晰度
      canvas.height = image.naturalHeight
      canvas.style.width = `${canvas.width / window.devicePixelRatio}px`
      canvas.style.height = `${canvas.height / window.devicePixelRatio}px`
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        return reject(new Error('canvas context not exist!'))
      }
      ctx.drawImage(image, 0, 0)
      const base64 = canvas.toDataURL('image/png')
      return resolve(base64)
    }
    image.onerror = err => {
      return reject(err)
    }
  })
}

export const imageUrlToObject = imageUrl => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.src = imageUrl
    img.onload = () => {
      resolve(img)
    }
    img.onerror = err => {
      return reject(err)
    }
  })
}
